module.exports = __webpack_public_path__ + "static/media/new_argologo_dark.e4370730.svg";